<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core';

const prefix = 'components.results.sortOptions.sortInfo';

defineProps<{ open: boolean }>();
defineEmits<{ 'update:open': [value: boolean] }>();

const breakpoints = useBreakpoints(breakpointsTailwind);
const isDesktop = breakpoints.greaterOrEqual('lg');
</script>

<template>
  <UiCustomInfoDialog
    :open="open"
    :variant="isDesktop ? 'dialog' : 'sheet'"
    :title="$t(`${prefix}.title`)"
    dialog-content-class="max-w-4xl"
    @update:open="$emit('update:open', $event)"
  >
    <div class="flex flex-col gap-3 text-sm leading-6 text-text-secondary-600">
      <p>
        <strong>{{ $t(`${prefix}.paragraph1`) }}</strong>
      </p>
      <i18n-t
        scope="global"
        :keypath="`${prefix}.paragraph2`"
        tag="p"
      >
        <template #duration>
          <strong>{{ $t(`${prefix}.paragraph2Duration`) }}</strong>
        </template>
        <template #relevance>
          <strong>{{ $t(`${prefix}.paragraph2Relevance`) }}</strong>
        </template>
      </i18n-t>
      <i18n-t
        scope="global"
        :keypath="`${prefix}.paragraph3`"
        tag="p"
      >
        <template #carbonEmission>
          <span class="underline">{{ $t(`${prefix}.paragraph3CarbonEmission`) }}</span>
        </template>
      </i18n-t>
      <p>
        {{ $t(`${prefix}.paragraph4`) }}
        <NuxtLink
          class="font-medium text-brand-primary-700 underline underline-offset-2"
          :to="$t(`${prefix}.learnMoreUrl`)"
          target="_blank"
        >
          {{ $t(`${prefix}.learnMore`) }}
        </NuxtLink>
      </p>
    </div>

    <div class="flex justify-end">
      <UiButton @click="$emit('update:open', false)">
        {{ $t(`${prefix}.continue`) }}
      </UiButton>
    </div>
  </UiCustomInfoDialog>
</template>
